import _ from "lodash";

export default {
    data() {
        return {
            mode: "MEDIA",

            dropdownItems: [
                { id: "MEDIA", label: "Todas" },
                { id: "ULTIMA", label: "Última" }
            ],

            fetchedStats: null
        };
    },

    props: {
        dataStats: {
            type: Object,
            required: true
        }
    },

    computed: {
        isNps() {
            return this.stats.type === "PESQUISA_NPS";
        },

        stats() {
            return this.dataStats;
        },

        interaction() {
            const interaction = _.cloneDeep(this.stats.interactionBody);

            interaction.estilo = JSON.parse(interaction.estilo);
            _.forEach(interaction.opcoes, (option, index) => {
                interaction.opcoes[index].estilo = JSON.parse(option.estilo);
            });

            return interaction;
        },

        currentStats() {
            return this.fetchedStats ? this.fetchedStats : this.stats;
        },

        answers() {
            return this.currentStats.optionResponses;
        },

        options() {
            return this.currentStats.interactionBody.opcoes;
        },

        screenTime() {
            const screenTime = (
                this.currentStats.screenTime /
                (this.currentStats.engagement + this.currentStats.rejection)
            ).toFixed(2);

            return isNaN(screenTime) ? 0 : screenTime;
        },

        engagement() {
            const engagement = (
                (this.currentStats.engagement /
                    (this.currentStats.engagement +
                        this.currentStats.rejection)) *
                100
            ).toFixed(0);

            return isNaN(engagement) ? 0 : engagement;
        },

        rejection() {
            const rejection = (
                (this.currentStats.rejection /
                    (this.currentStats.engagement +
                        this.currentStats.rejection)) *
                100
            ).toFixed(0);

            return isNaN(rejection) ? 0 : rejection;
        },

        filters() {
            return this.$store.state.statistics.filters;
        },

        values() {
            if (!this.isNps) {
                return _.map(this.options, option => {
                    return this.answers[option.id] || 0;
                });
            } else {
                const values = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];

                Object.keys(this.answers).forEach(key => {
                    const value = this.answers[key];

                    values[Number(key)] = Number(value);
                });

                return values;
            }
        },

        labels() {
            return !this.isNps
                ? _.map(this.options, value => {
                      return value.nome;
                  })
                : [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
        },

        data() {
            if (!this.chartBackground)
                throw Error(
                    '"chartBackground" should be defined inside data object'
                );

            return {
                datasets: [
                    {
                        backgroundColor: this.chartBackground,
                        data: this.values
                    }
                ],
                labels: this.labels
            };
        }
    },

    methods: {
        async load() {
            // this.fetchedStats =
            //     await this.$api.advertising.interactionStatistics({
            //         advertisingId: this.stats.campanhaId,
            //         interactionId: this.interaction.id,
            //         date: this.filters.date,
            //         devices: this.filters.devices,
            //         mode: this.mode,
            //     });

            this.buildChart();
        }
    },

    watch: {
        mode() {
            this.load();
        }
    }
};
